// extracted by mini-css-extract-plugin
export default {"bankAccountInput":"bankAccountInput--d0OY5","accountInput":"accountInput--Q6us2","hint":"hint--hExBN"};